import React, { useCallback } from 'react';
import PropTypes from 'prop-types';

import { SelectBox } from 'components/core/SelectBox';
import './sortDropDownVariation.scss';

export function SortDropDownVariation({ options = [
	{
		value: 'recommended',
		display: 'Recommended',
	},
	{
		value: 'star_rating_sf',
		display: 'Reviews',
	},
	{
		value: 'price',
		display: 'Price',
	},
	{
		value: 'distance',
		display: 'Distance',
	},
], value = 'recommended', onChange = () => {} }) {
	const handleChange = useCallback(
		(event) => {
			onChange({ order: event.target.value });
		},
		[onChange],
	);

	return (
		<div className="sort-container">
			<span className="sort-by-text">Sort By:</span>
			<SelectBox
				id="sort-by"
				label=""
				className="sort-dropdown-variation"
				onChange={handleChange}
				options={options}
				value={value}
				key={value}
			/>
		</div>
	);
}

SortDropDownVariation.propTypes = {
	options: PropTypes.arrayOf(
		PropTypes.shape({
			value: PropTypes.any,
			display: PropTypes.any,
		}),
	),
	value: PropTypes.string,
	onChange: PropTypes.func,
};

export default SortDropDownVariation;
